import React from "react";
import { ArrowRight, Scissors, Sparkles } from "lucide-react";
import type { StartClipping } from "./HeroSection";

interface FinalCTASectionProps {
  onStartClipping: StartClipping;
}

export const FinalCTASection: React.FC<FinalCTASectionProps> = ({
  onStartClipping,
}) => (
  <section
    id="final-cta"
    className="bg-white px-5 py-20 sm:px-6 sm:py-28 lg:px-8"
    aria-labelledby="final-cta-heading"
  >
    <div className="relative mx-auto max-w-6xl overflow-hidden rounded-[2rem] bg-[#effbff] px-6 py-16 text-center sm:px-12 sm:py-20">
      <div
        aria-hidden="true"
        className="absolute left-5 top-7 grid h-12 w-12 -rotate-6 place-items-center rounded-full border border-cyan-300 bg-white text-[var(--tc-blue)] sm:left-12 sm:top-10"
      >
        <Scissors className="h-5 w-5" />
      </div>
      <div
        aria-hidden="true"
        className="absolute bottom-7 right-5 grid h-12 w-12 rotate-6 place-items-center rounded-full border border-blue-300 bg-white text-[var(--tc-blue)] sm:bottom-10 sm:right-12"
      >
        <Sparkles className="h-5 w-5" />
      </div>
      <h2
        id="final-cta-heading"
        className="tc-section-title mx-auto max-w-3xl text-[var(--tc-ink)]"
      >
        Ready to start creating viral clips?
      </h2>
      <p className="mx-auto mt-5 max-w-2xl text-balance text-lg leading-8 text-[var(--tc-ink-muted)]">
        Add one YouTube link and quickly get clips ready to post
      </p>
      <div className="mt-9">
        <span className="relative inline-block before:absolute before:inset-0 before:translate-x-2 before:translate-y-2 before:rounded-2xl before:border before:border-cyan-400">
          <button
            type="button"
            onClick={() => void onStartClipping()}
            className="tc-primary-action relative inline-flex min-h-14 items-center justify-center gap-2 rounded-2xl bg-[var(--tc-blue)] px-8 text-lg font-bold text-white shadow-[var(--tc-shadow-cta)] transition hover:bg-[var(--tc-blue-hover)]"
          >
            Make my clips
            <ArrowRight aria-hidden="true" className="h-5 w-5" />
          </button>
        </span>
      </div>
    </div>
  </section>
);
